import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { format } from 'date-fns';
import { enUS, ja } from 'date-fns/locale';
import { CalendarDaysIcon } from '@heroicons/react/24/solid';
import { useTranslation } from 'react-i18next';

type DateFilterProps = {
  defaultDate?: string;
  onDateChange: (value: string) => void;
};

const DateFilter: React.FC<DateFilterProps> = ({
  defaultDate,
  onDateChange,
}) => {
  const { t, i18n } = useTranslation('common');
  const [selectedDate, setSelectedDate] = useState<Date | null>(
    defaultDate ? new Date(defaultDate) : null
  );
  const today = new Date().toISOString().slice(0, 10);

  const handleDateChange = (date: Date | null) => {
    setSelectedDate(date);
    onDateChange(date ? date.toISOString().slice(0, 10) : '');
  };

  const formatDate = (date: Date | null) => {
    if (!date) return '';
    const formattedDate = date.toISOString().slice(0, 10);
    return formattedDate === today
      ? t('date-filter.today')
      : format(date, t('date-filter.format'), {
          locale: i18n.language === 'jp' ? ja : enUS,
        });
  };

  return (
    <div className="inline-flex h-10 items-center p-4 pt-5 border rounded-md cursor-pointer max-w-fit">
      <DatePicker
        selected={selectedDate}
        onChange={handleDateChange}
        dateFormat={t('date-filter.format')}
        locale={i18n.language === 'jp' ? ja : enUS}
        customInput={
          <div className="flex gap-2 items-center">
            <CalendarDaysIcon className="w-5 h-5 text-primary/300" />
            <input
              type="text"
              value={formatDate(selectedDate)}
              readOnly
              className="w-36 focus:outline-none appearance-none cursor-pointer text-center"
            />
          </div>
        }
      />
    </div>
  );
};

export default DateFilter;
